import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import EditInvoices from "../Invoices/EditInvoices.js"





export default function Orders() {

    return (
        <Routes>
            <Route path="/edit/:id" element={<EditInvoices />} />
        </Routes>
    )
}


